import { parseCanvasChatPromptMessage } from '@littlebird/canvas';
import { type RefObject, useEffect } from 'react';

import { startChatWithPrompt } from '@/features/chat/start-chat-with-prompt';

/**
 * A canvas can offer the reader a follow-up question. It travels on its own channel rather than the
 * external-link one, so a shared or public canvas can prefill a composer but never navigate the app.
 */
export function useCanvasChatPrompt(
  iframeRef: RefObject<HTMLIFrameElement | null>,
  capability: string
): void {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.source !== iframeRef.current?.contentWindow) return;
      const prompt = parseCanvasChatPromptMessage(event.data, capability);
      if (!prompt) return;

      startChatWithPrompt(prompt);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [capability, iframeRef]);
}
